<template>
  <div class="video-instruction-step-flex">
    <div class="timestamp-col">
      <a
        v-if="firstTimestamp(props.timestamp_ref)"
        :href="`#t=${firstTimestamp(props.timestamp_ref)}`"
        class="timestamp-link"
      >
        {{ firstTimestamp(props.timestamp_ref) }}
      </a>
    </div>
    <div class="details-col">
      <div class="main-action">
        {{ props.action }}
      </div>
      <div class="criteria-line" v-if="props.look_for">
        <span class="criteria-bold">Look for:</span> {{ props.look_for }}
      </div>
      <div class="criteria-line" v-if="props.pass_criteria">
        <span class="criteria-bold">Pass criteria:</span> {{ props.pass_criteria }}
      </div>
      <div class="criteria-line" v-if="props.fail_criteria">
        <span class="criteria-bold">Fail criteria:</span> {{ props.fail_criteria }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  step_number: {
    type: Number,
    default: 1
  },
  action: {
    type: String,
    default: ""
  },
  look_for: {
    type: String,
    default: ""
  },
  pass_criteria: {
    type: String,
    default: ""
  },
  fail_criteria: {
    type: String,
    default: ""
  },
  timestamp_ref: {
    type: String,
    default: ""
  }
});

function firstTimestamp(ts) {
  // Extract first timestamp (e.g., '00:00' from '00:00-00:12')
  if (!ts) return '';
  const match = ts.match(/\d{2}:\d{2}/);
  return match ? match[0] : '';
}
</script>

<style scoped>
.video-instruction-step-flex {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 24px 0 0 0;
  font-family: Arial, sans-serif;
}
.timestamp-link {
  color: #355ffb;
  text-decoration: underline;
  font-size: 16px;
  font-weight: 400;
}
.details-col {
  flex: 1;
}
.main-action {
  color: #5c6670;
  font-size: 16px;
  font-weight: 400;
}
.criteria-line {
  color: #566171;
  font-size: 16px;
}
.criteria-bold {
  font-weight: bold;
  color: #374151;
}
</style>
